<template>
  <div class="IndoorVr">
    <div class="navlist">
      <div
        class="item"
        v-for="(item, index) in Vrlist"
        :key="index"
        :class="{ active: item.isactive }"
        @click="navclik(index)"
      >
        <div class="item-text">{{ item.type }}</div>
        <div class="item-number">{{ item.number }}</div>
      </div>
    </div>
    <iframe class="iw-html-frame" scrolling="no" :src="Vrurl"></iframe>
    <div class="shengming">装修展示仅供优化示意，实际以交付为准</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      Vrurl: "https://www.720yun.com/vr/ddajtskavy3",
      Vrlist: [
        {
          type: "合院",
          number: "230",
          url: "https://www.720yun.com/vr/ddajtskavy3",
          isactive: true
        },
        {
          type: "合院",
          number: "260",
          url: "https://www.720yun.com/vr/f59jtskavy4",
          isactive: false
        },
        {
          type: "上叠",
          number: "200",
          url: "https://www.720yun.com/vr/e21jtskavy6",
          isactive: false
        },
        {
          type: "下叠",
          number: "200",
          url: "https://www.720yun.com/vr/59cjtskavy0",
          isactive: false
        }
      ]
    };
  },
  created() {},
  mounted() {},
  methods: {
    navclik(index) {
      this.Vrurl = "";
      this.Vrurl = this.Vrlist[index].url;
      this.Vrlist.forEach(item => {
        item.isactive = false;
      });
      this.Vrlist[index].isactive = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.IndoorVr {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .navlist {
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    // width: 60px;
    padding: 10px;
    left: auto;
    left: 10px;
    top: 264px;
    /* top: 250px; */
    bottom: auto;
    margin: 0;
    z-index: 9999;
    border-radius: 18px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    // gap: 8px;
    .item {
      width: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 8px 0;
      transition: all 0.3s ease;
      
      .item-text {
        font-size: 14px;
        line-height: 1.2;
        margin-bottom: 2px;
      }
      
      .item-number {
        font-size: 13px;
        line-height: 1.2;
      }
    }
    .active {
      /* background: #fff; */
      color: #d5bda6;
    }
  }
  .shengming {
    position: absolute;
    bottom: 60px;
    right: 10px;
    color: #fff;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/IndoorVr.vue